import {VideoManager} from "../components/videoManager";

export default function Gallery({active, onLoading, onIsReady})
{
    return (
        <div id={"VideoComicGallery"}>
            <VideoManager active={active} onLoading={onLoading} onIsReady={onIsReady}/>
        </div>
    )
}